import { render } from "./CompanyDataWidget.vue?vue&type=template&id=ef7aaed6&scoped=true&ts=true"
import script from "./CompanyDataWidget.vue?vue&type=script&lang=ts"
export * from "./CompanyDataWidget.vue?vue&type=script&lang=ts"

import "./CompanyDataWidget.vue?vue&type=style&index=0&id=ef7aaed6&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7aaed6"]])

export default __exports__